/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_BILLING_PERIODS, GET_BILLING_PERIODS } from 'src/actions/billingPeriodActions';

const initialState = {
  items: [],
  isFetching: false,
  message: ''
};

const billingPeriodReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BILLING_PERIODS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_BILLING_PERIODS: {
      const { billingPeriods, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = billingPeriods;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default billingPeriodReducer;
